import { ToolboxOutlineIcon } from './ToolboxOutlineIcon';

/**
 * author: Google
 * id F016813A-4390-482A-8FFF-D081FDD21362
 * name toolbox-outline
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/toolbox-outline.svg
 * tags
 * - Hardware / Tools 
 */
export const ServiceToolboxIcon = ToolboxOutlineIcon;
export default ServiceToolboxIcon